import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-fa_user-cog",
  "use": "icon-fa_user-cog-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" class=\"lucide lucide-user-cog-icon lucide-user-cog\" id=\"icon-fa_user-cog\"><path d=\"M10 15H6a4 4 0 0 0-4 4v2\" /><path d=\"m14.305 16.53.923-.382\" /><path d=\"m15.228 13.852-.923-.383\" /><path d=\"m16.852 12.228-.383-.923\" /><path d=\"m16.852 17.772-.383.924\" /><path d=\"m19.148 12.228.383-.923\" /><path d=\"m19.53 18.696-.382-.924\" /><path d=\"m20.772 13.852.924-.383\" /><path d=\"m20.772 16.148.924.383\" /><circle cx=\"18\" cy=\"15\" r=\"3\" /><circle cx=\"9\" cy=\"7\" r=\"4\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/fa_user-cog.svg
// module id = zi8X
// module chunks = 63